import { render, staticRenderFns } from "./ititle.vue?vue&type=template&id=4fa65438&"
import script from "./ititle.vue?vue&type=script&lang=js&"
export * from "./ititle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports